import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {RouterStateSnapshot} from '@angular/router';
import {ActivatedRouteSnapshot} from '@angular/router';

@Injectable()
export class AdminOrClientOrEmployeeGuard implements CanActivate {
  constructor(private router: Router, private auth: AuthenticationService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.auth.userRole() === 'admin' || this.auth.userRole() === 'client' || this.auth.userRole() === 'employee') {
      return true;
    }

    this.router.navigate(['/login']);

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/guards/admin.or.client.or.employee.guard.ts